export const geoJsonFile = 'qld_lga_medium.geo.json';
export const dataFile = 'councils-data.json';
export const YEAR = process.env.REACT_APP_YEAR;

export const env =
  process.env.BRANCH != null && `${process.env.BRANCH}`.indexOf('staging') > -1
    ? 'staging'
    : process.env.NODE_ENV;



// WEBPACK FOOTER //
// ./src/config/index.js